const invitation = {
    find_your_tenants: '입주자 찾기',
    find_tenants_description: '귀하의 이메일 주소는 이미 여러 입주자와 등록되어 있을 수 있습니다. 기존 입주자에 가입하거나 새로운 입주자를 생성할 수 있습니다.',
    create_new_tenant: '신규 입주자 생성',
    email_not_match_title: '현재 다음으로\n{{email}}\n사용자로 로그인 중입니다',
    email_not_match_description: '초대장을 수락하고 조직의 구성원이 되려면 올바른 계정으로 로그인하십시오.',
    switch_account: '다른 계정으로 로그인',
    invalid_invitation_status: '잘못된 초대장입니다. 관리자에게 문의하고 다시 시도하십시오.',
    invitation_not_found: '초대장을 찾을 수 없습니다. 관리자에게 문의하십시오.',
};
export default Object.freeze(invitation);
